import { createTextVNode as u, Fragment as c, Comment as l } from "vue";
function h(n, e, t = "default") {
  const r = e[t];
  if (r === void 0)
    throw new Error(`[vueuc/${n}]: slot[${t}] is empty.`);
  return r();
}
function i(n, e = !0, t = []) {
  return n.forEach((r) => {
    if (r !== null) {
      if (typeof r != "object") {
        (typeof r == "string" || typeof r == "number") && t.push(u(String(r)));
        return;
      }
      if (Array.isArray(r)) {
        i(r, e, t);
        return;
      }
      if (r.type === c) {
        if (r.children === null)
          return;
        Array.isArray(r.children) && i(r.children, e, t);
      } else r.type !== l && t.push(r);
    }
  }), t;
}
function y(n, e, t = "default") {
  const r = e[t];
  if (r === void 0)
    throw new Error(`[vueuc/${n}]: slot[${t}] is empty.`);
  const f = i(r());
  if (f.length === 1)
    return f[0];
  throw new Error(`[vueuc/${n}]: slot[${t}] should have exactly one child.`);
}
export {
  i as flatten,
  y as getFirstVNode,
  h as getSlot
};
